import { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import Header from 'components/Layouts/components/Header';
import BusinessSidebar from './components/BusinessSidebar';

type Props = {
  children: JSX.Element;
};

export default function BusinessLayout({ children }: Props) {
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Header onMenuClick={handleDrawerToggle} />
      <Box bgcolor={theme.palette.background.default} display='flex' pt='66px'>
        <BusinessSidebar isMenuOpen={mobileOpen} handleClose={handleDrawerToggle} />
        <Box component='main' sx={{ flexGrow: 1, padding: 3 }}>
          {children}
        </Box>
      </Box>
    </>
  );
}
